import React from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';

const Navbar = () => {
  return (
    <Nav>
      <Logo>
        <img width={"80px"} src="https://img1.wsimg.com/isteam/ip/c38df292-980c-44d9-8918-875b813b21ce/Company_Logo.png/:/rs=w:208,h:208,cg:true,m/cr=w:208,h:208/qt=q:95" />      </Logo>
      <NavLinks>
        {/* <NavLink to="/">Login</NavLink> */}
        <NavLink to="/list">Transaction List</NavLink>
        <NavLink to="/transfer">Transfer</NavLink>
        <NavLink to="/keys">API Details</NavLink>
      </NavLinks>
    </Nav>
  );
};

export default Navbar;

// Styled Components

const Nav = styled.nav`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 20px;
  background-color: #E3D7C1;
  color: #333;
`;

const Logo = styled.div`
  font-size: 24px;
  font-weight: bold;
`;

const NavLinks = styled.div`
  display: flex;
  gap: 20px;
`;

const NavLink = styled(Link)`
  text-decoration: none;
  color: #333;
  font-size: 18px;
  position: relative;
  
  &.active {
    color: #f0a500;  // Active state color
  }

  &:hover {
    color: #f0a500;
  }

  &::after {
    content: '';
    position: absolute;
    width: 100%;
    height: 2px;
    background-color: #f0a500;
    bottom: -5px;
    left: 0;
    opacity: 0;
    transition: opacity 0.3s ease-in-out;
  }

  &:hover::after {
    opacity: 1;
  }
`;
